import { render, staticRenderFns } from "./orderSend.vue?vue&type=template&id=4dc8a54c&scoped=true"
import script from "./orderSend.vue?vue&type=script&lang=js"
export * from "./orderSend.vue?vue&type=script&lang=js"
import style0 from "./orderSend.vue?vue&type=style&index=0&id=4dc8a54c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc8a54c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/linyuqiu/IdeaProjects/huoquan/ningde-huoquan-supplier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dc8a54c')) {
      api.createRecord('4dc8a54c', component.options)
    } else {
      api.reload('4dc8a54c', component.options)
    }
    module.hot.accept("./orderSend.vue?vue&type=template&id=4dc8a54c&scoped=true", function () {
      api.rerender('4dc8a54c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/supplier/order/orderSend.vue"
export default component.exports